<template>
  <div
      class="header vh-100 p-1 p-md-5"
      :class="[`header${headerIndex % 3 + 1}`]"
  >
    <div class="overlay d-flex justify-content-end align-items-center p-1 p-md-5">
      <h1 class="title text-white text-right">
        Houd als ondernemer meer
        tijd over voor andere zaken
      </h1>

      <div class="w-100 d-flex justify-content-center p-5 scroll-down">
      <span class="scroll-icon">
        <span class="scroll-icon__wheel-outer">
          <span class="scroll-icon__wheel-inner"></span>
        </span>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      headerIndex: 1,
    };
  },
  methods: {
    incrementHeader() {
      this.headerIndex += 1;
      setTimeout(this.incrementHeader, 5000);
    },
  },
  created() {
    setTimeout(this.incrementHeader, 5000);
  },
};
</script>

<style scoped>
div.header {
  background-image: url(../assets/img/header/1.jpg) !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  overflow: hidden;
  transition-duration: 1000ms;
  transition-timing-function: ease-in-out;
  min-height: 100%;
}

.overlay {
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
}

div.header1 {
  background-image: url('../assets/img/header/1.jpg') !important;
}

div.header2 {
  background-image: url('../assets/img/header/2.jpg') !important;
}

div.header3 {
  background-image: url('../assets/img/header/3.jpg') !important;
}

div.scroll-down {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.scroll-icon {
  display: block;
  position: relative;
  height: 4em;
  width: 2.3em;
  border: 1px solid #fff;
  border-radius: 1.3em;
}

@keyframes scroll_1 {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-0.6em);
  }
  50% {
    transform: translateY(0);
  }
  75% {
    transform: translateY(0.6em);
  }
  100% {
    transform: translateY(0);
  }
}

.scroll-icon__wheel-outer {
  display: block;
  position: absolute;
  left: 50%;
  top: .6em;
  height: 1em;
  width: .4em;
  margin-left: -.2em;
  border-radius: .4em;
  overflow: hidden;
}

.scroll-icon__wheel-inner {
  display: block;
  height: 100%;
  width: 100%;
  border-radius: inherit;
  background: #fff;
  animation: scroll_1 2.75s ease-in-out infinite;
}
</style>
